import React, { Suspense } from 'react';

import { useLazyComponent } from '@trello/use-lazy-component';
import { ChunkLoadErrorBoundary } from 'app/src/components/ChunkLoadErrorBoundary';
import { ViewSwitcherProps } from './ViewSwitcher';

export const LazyViewSwitcher: React.FunctionComponent<ViewSwitcherProps> = (
  props,
) => {
  const ViewSwitcher = useLazyComponent(
    () => import(/* webpackChunkName: "view-switcher" */ './ViewSwitcher'),
    { namedImport: 'ViewSwitcher' },
  );

  return (
    <Suspense fallback={null}>
      <ChunkLoadErrorBoundary fallback={null} retryAfter={15000}>
        <ViewSwitcher {...props} />
      </ChunkLoadErrorBoundary>
    </Suspense>
  );
};
